import {isInAndroidApp, isInMobileApp} from "./MobileUtils";
import router from "../router";
import Vue from "vue";

export function openSubscribePage(back: string = router.currentRoute.path, from: string | undefined = undefined, redirectForMobile: string | undefined = undefined, promoCode: string | undefined = undefined, annual: boolean = false) {
  if (isInMobileApp() && isInAndroidApp()) {
    const serv: 'test' | 'web' = process.env.API_URL?.includes('test') ? 'test' : 'web';
    let subscribeUrl = `https://www.${serv}.tokatab.com/#/auth?token=${localStorage.tokenTokatab}&redirectUrl=/subscribe?back=${back}%26from=${from}%26fromMobileApp=true`;
    if (promoCode) {
      subscribeUrl += `%26promoCode=${promoCode}`;
    }
    if (annual) {
      subscribeUrl += `%26annual=true`;
    }
    Vue.prototype.MobileBrowser.openOutsideOfApp(subscribeUrl);

    if (redirectForMobile) {
      router.push({ path: redirectForMobile });
    }

    this.$root.$emit('displayWaitingSubscriptionModal');
  }
  else {
    const query: any = { back, from };
    if (promoCode) {
      query.promoCode = promoCode;
    }
    if (annual) {
      query.annual = true;
    }
    router.push({ path: '/subscribe', query });
  }
}

export function openDownloadPartition(back: string = router.currentRoute.path) {
  const {playableType, playableId, artist, songname} = router.currentRoute.params;
  const url = `/song/${playableType}/${playableId}/${artist}/${songname}/partition`
  if (isInMobileApp()) {
    const serv: 'test' | 'web'  = process.env.API_URL?.includes('test') ? 'test' : 'web'
    Vue.prototype.MobileBrowser.openOutsideOfApp(`https://www.${serv}.tokatab.com/#/auth?token=${localStorage.tokenTokatab}&redirectUrl=${url}?back=${back}`)
  }
  else {
    router.push({path: url, query : {back}});
  }
}
